import { Colors, Utils } from '@lightningjs/sdk';
import lng from '@lightningjs/core';
export default class VODComponent extends lng.Component {
  static _template() {
    return {
      collision: true,
      Item: {
        Image: {},
        IsLockedIcon: {},
      },
      FocusRing: {
        alpha: 0,
      },
    };
  }

  _construct() {
    super._construct();
    this.spacing = 10;
    this.radius = 4;
  }

  set src(val) {
    this._src = val;
  }

  get src() {
    return this._src;
  }

  set isProtected(val) {
    this._isProtected = val;
  }

  set isLocked(val) {
    this._isLocked = val;
  }

  set index(val) {
    this._index = val;
  }

  set rowIndex(val) {
    this._rowIndex = val;
  }

  get _Image() {
    return this.tag('Item.Image');
  }

  get _LockedIcon() {
    return this.tag('Item.IsLockedIcon');
  }

  get _FocusRing() {
    return this.tag('FocusRing');
  }

  _active() {
    this.tag('Image').on('txError', () => {
      this.tag('Image').patch({
        rtt: true,
        zIndex: 2,
        w: this.w,
        h: this.h,
        texture: {
          type: lng.textures.ImageTexture,
          src: this.data.originalImage,
          resizeMode: { type: 'cover', w: this.w, h: this.h },
        },
      });
    });
  }

  _enable() {
    this._setIntoActive();
    if (this.data.kind === 'collection') {
      this._Image.patch({
        shader: { type: lng.shaders.RoundedRectangle, radius: 15 },
      });
    } else if (this.data.kind === 'movie' || this.data.kind === 'subseries') {
      this._Image.patch({
        shader: { type: lng.shaders.RoundedRectangle, radius: 12 },
      });
    }
    // this.fireAncestors('$changeVODInfo', {
    //   title: this.data.title,
    //   description: this.data.description,
    //   category: this.data.category,
    //   duration: this.data.duration,
    //   rating: this.data.rating,
    //   votes: this.data.votes,
    //   contentRating: this.data.contentRating,
    //   id: this.data.id,
    //   kind: this.data.kind,
    // });
  }

  _focus() {
    this.fireAncestors('$changeVODInfo', {
      title: this.data.title,
      description: this.data.description,
      cover: this.data.cover,
      category: this.data.category,
      duration: this.data.duration,
      rating: this.data.rating,
      votes: this.data.votes,
      contentRating: this.data.contentRating,
      id: this.data.id,
      kind: this.data.kind,
    });
    this._FocusRing.smooth = { alpha: 1, scale: 1.1 };
    this._Image.smooth = { scale: 1.1 };
    this._LockedIcon.smooth = {
      y: 0,
      x: 153,
      zIndex: 30,
    };
    this._LockedIcon.smooth = { scale: 1.6 };
  }

  _unfocus() {
    this._FocusRing.smooth = { alpha: 0, scale: 1 };
    this._Image.smooth = { scale: 1 };
    this._LockedIcon.smooth = { scale: 1.2 };
    this._LockedIcon.smooth = {
      zIndex: 30,
      x: 150,
      y: 4,
    };
  }

  _setIntoActive() {
    this._FocusRing.smooth = { alpha: 0, scale: 1 };
    this._Image.smooth = { scale: 1 };
    this._LockedIcon.smooth = { scale: 1.2 };
    if (this.data.kind === 'collection') {
      this._FocusRing.patch({
        w: this.w + this.spacing - 2,
        h: this.h + this.spacing - 2,
        mount: 0.5,
        x: this.w / 2,
        y: this.h / 2,
        zIndex: 2,
        texture: lng.Tools.getRoundRect(
          this.w + this.spacing,
          this.h + this.spacing,
          15,
          5,
          Colors('#02AC25').get(),
          false
        ),
      });
    } else if (this.data.kind === 'movie' || this.data.kind === 'subseries') {
      this._FocusRing.patch({
        w: this.w + this.spacing - 2,
        h: this.h + this.spacing - 2,
        mount: 0.5,
        x: this.w / 2,
        y: this.h / 2,
        zIndex: 2,
        texture: lng.Tools.getRoundRect(
          this.w + this.spacing,
          this.h + this.spacing,
          12,
          5,
          Colors('#02AC25').get(),
          false
        ),
      });
    } else {
      this._FocusRing.patch({
        w: this.w + this.spacing,
        h: this.h + this.spacing,
        mount: 0.5,
        x: this.w / 2,
        y: this.h / 2,
        zIndex: 2,
        texture: lng.Tools.getRoundRect(
          this.w + this.spacing,
          this.h + this.spacing,
          0,
          5,
          Colors('#02AC25').get(),
          false
        ),
      });
    }
    this._Image.patch({
      clipping: true,
      rtt: true,
      zIndex: 2,
      w: this.w,
      h: this.h,
      texture: {
        type: lng.textures.ImageTexture,
        src: this._src,
        resizeMode: { type: 'cover', w: this.w, h: this.h },
      },
    });
    if (!this._isProtected) {
      if (this._isLocked) {
        this._LockedIcon.smooth = { scale: 1.2 };

        if (this._isLocked) {
          this._LockedIcon.patch({
            zIndex: 2,
            x: 150,
            y: 4,
            texture: lng.Tools.getSvgTexture(
              Utils.asset('images/movie-info-icons/dollar.png'),
              50,
              50
            ),
            w: 50,
            h: 50,
            shader: {
              type: lng.shaders.RoundedRectangle,
              radius: [0, 12, 0, 0], // topLeft = 12, ostali = 0
            },
          });
        }
      }
    } else {
      if (this._isProtected) {
        this._LockedIcon.patch({
          zIndex: 2,
          x: 150,
          y: 4,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/lock.svg'), 50, 50),
          w: 50,
          h: 50,
          shader: {
            type: lng.shaders.RoundedRectangle,
            radius: [0, 12, 0, 0], // topLeft = 12, ostali = 0
          },
        });
      }
    }
  }

  _handleEnter() {
    this.fireAncestors('$handleEnter');
  }

  _handleClick() {
    this._handleEnter();
  }

  // Magic Remote
  _handleHover(event) {
    this.fireAncestors('$unselectCurrentIndex');
    this.fireAncestors('$setFocus', { rowIndex: this._rowIndex, index: this._index });
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleScroll(event) {
    this.fireAncestors('$scroll', event);
    this._unfocus();
  }
}
